if (!customElements.get('password-toggle')) {
  class PasswordToggle extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLInputElement | null} */
      this.input = this.querySelector('input');

      /** @type {HTMLButtonElement | null} */
      this.button = this.querySelector('button');

      if (!this.input || !this.button) return;

      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      if (!this.input) return;
      const isPassword = this.input.type === 'password';
      this.input.type = isPassword ? 'text' : 'password';
      this.classList.toggle('is-visible', isPassword);
    }
  }

  customElements.define('password-toggle', PasswordToggle);
}
